export class CmsRedirection {
  destination: string;
  permanent: boolean;

  constructor(params: { destination: string; permanent: boolean }) {
    this.destination = params.destination;
    this.permanent = params.permanent;
  }
}
